module.exports = __webpack_public_path__ + "img/global.e72ae145.png";